import * as Sentry from '@sentry/node';
import axios from 'axios';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PulseLoader from 'react-spinners/PulseLoader';
import { useLeadContext } from '../../context/Lead';
import { usePaymentContext } from '../../context/Payment';

// import styles from './styles'

interface PaymentButtonProps {}

const PaymentButton: React.FC<PaymentButtonProps> =
  ({}: PaymentButtonProps) => {
    const [disabled, setDisabled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [customerExists, setCustomerExists] = useState<boolean>(false);
    const { paymentState, sendToPaymentState } = usePaymentContext();
    const { lead } = useLeadContext();
    const router = useRouter();
    const [errorMessages, setErrorMessages] = useState<string[]>([]);
    const [hover, setHover] = useState<boolean>(false);

    useEffect(() => {
      switch (true) {
        case paymentState.matches('idle') &&
          paymentState.event.type === 'ACCEPTED':
          setDisabled(false);
          break;
        case paymentState.matches('idle'):
          setDisabled(true);
          break;
        case paymentState.matches('ready'):
          setDisabled(false);
          break;
        case paymentState.matches('transactionPending'):
        case paymentState.matches('schedulePending'):
          setDisabled(true);
          setLoading(true);
          break;
        case paymentState.matches('transactionFail'):
        case paymentState.matches('scheduleFail'):
          setDisabled(false);
          setLoading(false);
          break;
        case paymentState.matches('scheduleSuccess'):
          setLoading(false);
          break;
        default:
          break;
      }
    }, [paymentState]);

    useEffect(() => {
      const errors = [];
      setErrorMessages([]);
      if (
        !paymentState.context.cardValidated
      ) {
        errors.push('Please enter valid credit card info');
      }
      if (!paymentState.context.termsAccepted) {
        errors.push('Please check terms and conditions');
      }
      
      if (!paymentState.context.cardValidated) {
        setDisabled(true);
      }
      if (
        !lead.addressLineOne ||
        !lead.city ||
        !lead.state ||
        !lead.zipCode
      ) {
        errors.push('Please enter all address information');
      }
      if (
        !paymentState.context.cardValidated &&
        paymentState.context.termsAccepted
      ) {
        setDisabled(false);
      }
    
    if (errors.length > 0) {
      setErrorMessages(errors);
    }
    }, [paymentState]);

    const startRequest = () => {
      sendToPaymentState('START');
    };

    useEffect(() => {
      if (!lead?.email) return;
        axios
          .post('/api/check-if-customer-exists/', { email: lead.email })
          .then((res) => {
            if (res.status === 200) {
              setCustomerExists(res.data.data.has_completed_appointments)
              console.log('Anything')
              console.log('Does the customer exist?', customerExists)
            } else {
              setCustomerExists(false)
            }
          }).catch(err => {
            console.log('In the catch of check if customer exists')
            Sentry.captureException(err)
          });
    }, [lead.email]);

    return (
      <>
        <Button
          id='SubmitPaymentMethod'
          disabled={disabled}
          onMouseLeave={() => setHover(false)}
          onMouseEnter={() => setHover(true)}
          onClick={() => {
            startRequest();
          }}
          className='payment-button'
          style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
        >
          <div className='justify-content-between d-flex flex-row align-items-center'>
            SCHEDULE NOW{' '}
            {loading && (
              <span className='ml-2'>
                <PulseLoader size={8} color={hover ? '#fff' : '#cf2680'} loading={loading} />
              </span>
            )}
          </div>
          {errorMessages.length > 0 && !loading && (
            // <span className='payment-tooltip'>
            //   {!lead.zipCode
            //     ? 'Please fill in all the information'
            //     : !paymentState.context.cardValidated && !customerExists
            //     ? 'Please enter valid credit card info'
            //     : !paymentState.context.termsAccepted
            //     ? 'Please check terms and conditions'
            //     : !lead.city || !lead.state
            //     ? 'Please enter city and state'
            //     : 'Please enter valid credit card info'}

            // </span>

            <ol className='payment-tooltip'>
              {errorMessages.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ol>
          )}
        </Button>
      </>
    );
  };

PaymentButton.defaultProps = {
  // add payment button default props here
  // className: null,
};

export default PaymentButton;
